// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3GaY0","fileBtn":"File_fileBtn__1as8P","closeBtn":"File_closeBtn__pPHGo","fileSelected":"File_fileSelected__Cn-Lr","disabled":"File_disabled__1R5Ag"};